/**
 * @module TestDetailMemoSections
 * @description Phase 17 extraction of memoized Test Detail section wrappers and WiFi helpers.
 * Reduces TestDetailPanel import density while keeping section composition explicit.
 */

import React from 'react';

import TestBaseInformationSection from './sections/TestBaseInformationSection';
import TestRunScheduleSection from './sections/TestRunScheduleSection';
import TestPathAnalysisSection from './sections/TestPathAnalysisSection';
import TestRunOnnPointsSection from './sections/TestRunOnnPointsSection';
import TestRequestParametersSection from './sections/TestRequestParametersSection';
import TestExpectedResponseSection from './sections/TestExpectedResponseSection';
import TestSmartEdgeMonitoringSection from './sections/TestSmartEdgeMonitoringSection';
import TestThresholdsSection from './sections/TestThresholdsSection';
import TestNotificationsSection from './sections/TestNotificationsSection';
import TestDynamicConfigSection from './sections/dynamic-config/TestDynamicConfigSection';
import TestBttCertificateSection from './sections/btt-certificate/TestBttCertificateSection';
import { VoipPhoneTestConfigSection } from './sections/voip/VoipPhoneTestConfigSection';
import { VoipPulseTestConfigSection } from './sections/voip/VoipPulseTestConfigSection';

// Memoize non-verify sections to prevent unnecessary re-renders
// when verify state changes (showVerify/verifyLoading/verifyResult).
export const MemoBaseInformation = React.memo(TestBaseInformationSection);
export const MemoRunSchedule = React.memo(TestRunScheduleSection);
export const MemoPathAnalysis = React.memo(TestPathAnalysisSection);
export const MemoRunOnnPoints = React.memo(TestRunOnnPointsSection);
export const MemoVoipPhone = React.memo(VoipPhoneTestConfigSection);
export const MemoVoipPulse = React.memo(VoipPulseTestConfigSection);
export const MemoRequestParams = React.memo(TestRequestParametersSection);
export const MemoExpectedResponse = React.memo(TestExpectedResponseSection);
export const MemoDynamicConfig = React.memo(TestDynamicConfigSection);
export const MemoBttCertificate = React.memo(TestBttCertificateSection);
export const MemoSmartEdge = React.memo(TestSmartEdgeMonitoringSection);
export const MemoThresholds = React.memo(TestThresholdsSection);
export const MemoNotifications = React.memo(TestNotificationsSection);
